import { render } from "./NoteCreate.vue?vue&type=template&id=02a87475"
import script from "./NoteCreate.vue?vue&type=script&lang=js"
export * from "./NoteCreate.vue?vue&type=script&lang=js"

import "./NoteCreate.vue?vue&type=style&index=0&id=02a87475&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__